import axios from "axios";
import { API_URL } from "../constants";
import { UserInfo } from "../contexts/UserInfoContext";
import { GetUserRes } from "../models/User";
import { resolveAccessToken } from "./Auth";

export async function getUsers(
  userInfo?: UserInfo
): Promise<GetUserRes[] | undefined> {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (token) {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(`${API_URL}users`, {
        headers,
      });

      return response.data;
    } catch (error) {
      return undefined;
    }
  } else return undefined;
}

export async function addUser(
  formData: any,
  userInfo?: UserInfo
): Promise<any> {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (token) {
    return new Promise((resolve, reject) => {
      const requestBody = {
        users: [
          {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            clientId: formData.clientId,
          },
        ],
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .post(`${API_URL}/users`, requestBody, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
      return "success";
    });
  } else return undefined;
}

export async function updateUser(
  formData: any,
  userId: string,
  userInfo?: UserInfo
): Promise<any> {
  console.log("Not implemented");
}

export async function resetCognitoUserPassword(
  userInfo?: UserInfo
): Promise<any> {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (!token) {
    return Promise.reject(new Error("Session expired"));
  }
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios
    .post(`${API_URL}/reset-cognito-user-password`, {}, config)
    .then((response) => response.data);
}
